// Client-side fetch for /api/track-features (see src/routes/api.js and
// src/services/trackFeaturesService.js) - the Deezer BPM + TheAudioDB
// energy/danceability/valence/mood lookup that feeds orchestrator.js.
// Mirrors artwork-palette.js's role: a plain async function main.js calls
// on track change, whose result gets attached back onto the profile via
// SonosVisualProfileSource.setTrackFeatures().

import { API_BASE } from './api-base.js';

// duration (seconds, from Sonos) is optional - passed through so the
// server can disambiguate between several same-titled Deezer candidates
// (see trackFeaturesService.js's pickClosestDuration).
export function fetchTrackFeatures(title, artist, duration) {
  let url = API_BASE + '/api/track-features?title=' + encodeURIComponent(title) + '&artist=' + encodeURIComponent(artist);
  if (duration != null) url += '&duration=' + encodeURIComponent(duration);
  return fetch(url).then(function (res) {
    if (!res.ok) throw new Error('track-features request failed: ' + res.status);
    return res.json();
  });
}
